import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { environment } from '../environments/environment';

import { EmedHomeComponent } from './components/emed-home/emed-home.component';
import { EmedMainDispatcherComponent } from './modules/dispatcher/components/emed-main-dispatcher/emed-main-dispatcher.component';

export const routes: Routes = [
  { path: '', redirectTo: environment.baseUrl, pathMatch: 'full' },
  {
    path: 'main',
    component: EmedHomeComponent,
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: 'dispatcher',
        component: EmedMainDispatcherComponent,
        runGuardsAndResolvers: 'always',
        children: [
          {
            path: '',
            runGuardsAndResolvers: 'always',
            loadChildren: () => import('./modules/dispatcher/dispatcher.module').then((mod) => mod.DispatcherModule)
          }
        ]
      },
      {
        path: 'configurazione',
        component: EmedMainDispatcherComponent,
        runGuardsAndResolvers: 'always',
        children: [
          {
            path: '',
            runGuardsAndResolvers: 'always',
            loadChildren: () => import('./modules/configurazione/configurazione.module').then((mod) => mod.ConfigurazioneModule)
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
